import { Component, OnInit } from '@angular/core';
import { faTrash, faPlus, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FormArray, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DealersService } from "../../share/services/dealers/dealers.service";
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { MessageService } from 'src/app/share/sharedsubject';

@Component({
    selector: 'app-add-product',
    templateUrl: './add-product.component.html',
    styleUrls: ['./add-product.component.scss'],
    standalone: false
})

export class AddProductComponent implements OnInit {

  customSearchFn = () => true;
  addOrderOutForm: FormGroup;
  filteredActiveBranches: any[] = [];
  isLoading = false;
  modelList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];
  responseMsg: string;
  selectedStockInId: any;
  isEditStock: boolean = false;
  editParamMode: 'editId' | 'udid' | 'id' | null = null;
  isStockChanged: boolean = false;
  initialStockData: any[] = [];
  showEditReasonField: boolean = false;
  showUploadForm = false;
  selectedFile: File | null = null;
  dealerList: any[] = [];
  userDetails: any;
  tyreMakeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreSizeObj: any = { page: 0, searchTerm: '', list: [] };
  tyreModelObj: any = { page: 0};
  dealerObj: any = { page: 0 };
  endOfDealerList: boolean = false;
  priceDetailsArray: { minPrice: number; maxPrice: number; avgPrice: number }[] = [];
  todayDate: string = (() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  })();
  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;
  protected readonly faArrowLeft = faArrowLeft;

  futureDateValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const selectedDate = String(control.value).split('T')[0];
    if (selectedDate > this.todayDate) {
      return { futureDate: true };
    }
    return null;
  };

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly stockService: StockService,
    private readonly companyService: CompanyServiceService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly dealersService: DealersService,
    private readonly masterModelService: MasterModelService,
    private readonly masterMakeService: MasterMakeService,
    private readonly storageService: StorageService,
    private readonly messageService: MessageService,

  ) {

  }

  stockInFormBuiler() {
    this.addOrderOutForm = this.formBuilder.group({
      company: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [this.userDetails.company],
      dealer: [null, [Validators.required]],
      isUploadInvoiceCheckbox: [false],
      invoice: [''],
      invoiceFile: [''],
      invoiceNumber: [''],
      invoiceDate: ['', [this.futureDateValidator]],
      editReason: [''],
      stock: this.formBuilder.array([this.createItemGroup()])
    });
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
  }

  createItemGroup(): FormGroup {
    return this.formBuilder.group({
      tyreSize: [null, Validators.required],
      tyreMake: [null, Validators.required],
      tyreModel: [null],
      quantity: [null, Validators.required],
      purchasingPrice: [null, Validators.required],
      minAmount:[''],
      maxAmount:['']
    });
  }

  get stock(): FormArray {
    return this.addOrderOutForm.get('stock') as FormArray;
  }

  addItem(index: number): void {
    if (this.selectedStockInId) return;
    this.stock.push(this.createItemGroup());
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
    this.tyreModelObj = { page: 0, name: '' };
    this.modelList.push({ search: '', list: [], page: 0 });          
  }

  removeItem(index: number): void {
    if (this.selectedStockInId) return;
    this.stock.removeAt(index);
    this.priceDetailsArray.splice(index, 1);
    this.modelList.splice(index, 1);
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    this.initData();
    this.stockInFormBuiler();
    if (this.userDetails?.enrollmentType === 'Company') {
      this.getAllCompanyList();
    }
    this.activatedRoute.queryParams.subscribe((res) => {
      if (res['editId']) {
        this.editParamMode = 'editId';
        this.selectedStockInId = res['editId'];
      } else if (res['udid']) {
        this.editParamMode = 'udid';
        this.selectedStockInId = res['udid'];
      } else if (res['id']) {
        this.editParamMode = 'id';
        this.selectedStockInId = res['id'];
      }

      if (this.selectedStockInId) {
        this.isEditStock = true;
        this.getStockInById();
      } else {
        this.getDealers();
      }
    });
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.filteredActiveBranches = (res.data || [])?.filter((c: any) => c.status === 'Active') || [];
    });
  }

  onScrollTyreSize() {
    if (this.tyreSizeObj.list.length % 20 === 0 ) {
      this.tyreSizeObj.page++;
      this.getTyreSize();
    }
  }

  onTyreSizeInputChange(event: any) {
    this.tyreSizeObj.page = 0;
    let tyreSizeSearch = event?.term ? event.term : '';
    this.tyreSizeObj.searchTerm = tyreSizeSearch;
    this.tyreSizeObj.list = [];
    this.getTyreSize();
  }

  onOptionsSelected(selectedTyreSize: any, index: any) {
    let selectedTyreData = this.tyreSizeObj.list.find((tyre: any) => tyre.tyreSize === selectedTyreSize)
    this.addOrderOutForm.controls["minAmount"].setValue(selectedTyreData?.minAmount)
    this.addOrderOutForm.controls["maxAmount"].setValue(selectedTyreData?.maxAmount)
    this.addOrderOutForm.controls["average"].setValue(selectedTyreData?.average)
  }


  onTyreMakeInputChange(event: any) {
    this.tyreMakeObj.page = 0;
    let tyreMakeSearch = event?.term ? event.term : '';
    this.tyreMakeObj.searchTerm = tyreMakeSearch;
    this.tyreMakeObj.list = [];
    this.getTyreMake();
  }

  selectMake(value: any, index: any) {
    this.modelList[index].list = [];
    this.modelList[index].page = 0;
    this.modelList[index].search = '';
    let selectedTyreMake = value || ''
    let selectedTyre: any = this.stock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.tyreModelObj.name = '';
    this.tyreModelObj.tyreMake = selectedTyreMake
    this.tyreModelObj.page = 0
    if(value){
      this.getTyreModel(index, this.tyreModelObj);
    }
  }

  scroll(index: number) {
  if (this.modelList[index].list.length % 20 === 0 ) return;
  this.modelList[index].page++
  this.tyreModelObj.page = this.modelList[index].page;
  let selectedGroup: any = this.stock?.controls[index];
  let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
  this.tyreModelObj.tyreMake = selectedTyreMake;
    this.tyreModelObj.name = this.modelList[index].search;
  this.getTyreModel(index);
  }

  onTyreModelInputChange(event: any, index: number) {
    this.tyreModelObj.page = 0;
    let tyreModelSearch = event?.term ? event.term : '';
    this.modelList[index].list = [];
    this.modelList[index].search = tyreModelSearch;
    this.modelList[index].page = 0;
    this.tyreModelObj.name = tyreModelSearch;
    let selectedGroup: any = this.stock?.controls[index];
    let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = selectedTyreMake;
    this.getTyreModel(index, this.tyreModelObj);
  }

  getTyreModel(index: number, selectedMake?: any) {
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res: any) => {
      if (this.tyreModelObj.page == 0) {
        this.modelList[index].list = res.data || [];
      }
      else {
        this.modelList[index].list = this.modelList[index].list.concat(res.data || []);
      }
    });
  }

  getTyreMake() {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      if (this.tyreMakeObj.page === 0) {
        this.tyreMakeObj.list = res.data || [];
      } else {
        this.tyreMakeObj.list = [...this.tyreMakeObj.list, ...(res.data || [])];
      }
    });
  }

  getDealers() {
    this.dealersService.getDealerDetails(this.dealerObj).subscribe((res: any) => {
      this.dealerList = this.dealerList.concat(res.data || []);
      if (res.data.length === 0) {
        this.endOfDealerList = true;
      }
    })
  }

  // to get tyre pattrens
  getTyreSize() {
    const apiParams: any = { page: this.tyreSizeObj.page };
    if (this.tyreSizeObj.searchTerm) {
      apiParams.searchTerm = this.tyreSizeObj.searchTerm;
    }
    this.stockService.getTyreDetails(apiParams).subscribe((res: any) => {
      if (this.tyreSizeObj.page === 0) {
        this.tyreSizeObj.list = res.data || [];
      } else {
        this.tyreSizeObj.list = [...this.tyreSizeObj.list, ...(res.data || [])];
      }
    });
  }

  getStockInById() {
    this.stockService.getStockInByStockInById(this.selectedStockInId).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.populateStockInData(res.data);
        }
      },
      error: (error: any) => {
        this.handleError(error);
      }
    });
  }

  private populateStockInData(data: any) {
    this.addOrderOutForm.patchValue({
      company: data.company?._id,
      invoiceNumber: data.invoiceNumber,
      invoiceDate: data.invoiceDate ? data.invoiceDate.split('T')[0] : '',
      isUploadInvoiceCheckbox: data.isUploadInvoiceCheckbox || false,
      invoice: data.invoice
    });

    this.showUploadForm = !!(data.isUploadInvoiceCheckbox || data.invoice);

    if (data.dealer) {
      this.dealerList = [data.dealer];
      this.addOrderOutForm.patchValue({ dealer: data.dealer._id });
    }

    this.addOrderOutForm.get('company')?.disable();
    this.addOrderOutForm.get('dealer')?.disable();

    if (this.editParamMode === 'editId') {
      this.addOrderOutForm.get('isUploadInvoiceCheckbox')?.disable();
      this.addOrderOutForm.get('invoiceFile')?.disable();
      this.addOrderOutForm.get('invoiceDate')?.disable();
      this.showEditReasonField = true;
      this.addOrderOutForm.get('editReason')?.setValidators([Validators.required]);
      this.addOrderOutForm.get('editReason')?.updateValueAndValidity();
    }
    if (data?.invoiceNumber || this.editParamMode === 'editId') {
      this.addOrderOutForm.get('invoiceNumber')?.disable();
    }

    const stockFormArray = this.addOrderOutForm.get('stock') as FormArray;
    stockFormArray.clear();
    this.priceDetailsArray = [];
    this.modelList = [];
    this.initialStockData = [];

    if (data.stock && Array.isArray(data.stock)) {
      data.stock.forEach((item: any) => {
        const quantity = item.editedQuantity ?? item.quantity ?? 0;
        const purchasePrice = item.editedPurchasingPrice ?? item.purchasingPrice ?? 0;
        const unitPrice = quantity > 0 ? (purchasePrice / quantity) : 0;
        const group = this.createItemGroup();
        group.patchValue({
          tyreSize: item.tyreSize,
          tyreMake: item.tyreMake,
          tyreModel: item.tyreModel,
          quantity: quantity,
          purchasingPrice: unitPrice,
          minAmount: item.minAmount || '',
          maxAmount: item.maxAmount || ''
        });

        this.initialStockData.push({
          quantity: quantity,
          purchasingPrice: unitPrice
        });

        group.get('tyreSize')?.disable();
        group.get('tyreMake')?.disable();
        group.get('tyreModel')?.disable();
        group.get('minAmount')?.disable();
        group.get('maxAmount')?.disable();

        if (this.editParamMode === 'udid') {
          group.get('quantity')?.disable();
          group.get('purchasingPrice')?.disable();
        }

        stockFormArray.push(group);

        this.priceDetailsArray.push({
          minPrice: item.minAmount || 0,
          maxPrice: item.maxAmount || 0,
          avgPrice: 0
        });
        
        this.modelList.push({ search: '', list: [{ name: item.tyreModel }], page: 0 });
      });
    }

    if (this.editParamMode === 'id') {
      stockFormArray.valueChanges.subscribe(() => {
        this.checkIfStockChanged();
      });
    }
  }

  checkIfStockChanged() {
    if (this.editParamMode !== 'id' || !this.initialStockData.length) return;
    const currentStock = this.addOrderOutForm.getRawValue().stock || [];
    let hasChanges = false;

    if (currentStock.length === this.initialStockData.length) {
      currentStock.forEach((item: any, idx: number) => {
        const init = this.initialStockData[idx];
        if (init) {
          if (Number(item.quantity) !== Number(init.quantity) || Number(item.purchasingPrice) !== Number(init.purchasingPrice)) {
            hasChanges = true;
          }
        } else {
          hasChanges = true;
        }
      });
    } else {
      hasChanges = true;
    }

    this.isStockChanged = hasChanges;
    this.showEditReasonField = hasChanges;
    const editReasonCtrl = this.addOrderOutForm.get('editReason');
    if (hasChanges) {
      editReasonCtrl?.setValidators([Validators.required]);
    } else {
      editReasonCtrl?.clearValidators();
      editReasonCtrl?.setValue('');
    }
    editReasonCtrl?.updateValueAndValidity();
  }

  onInvoiceCheckboxChange(event: any) {
    const isChecked = event?.target?.checked;
    this.showUploadForm = isChecked;
    if (!isChecked) {
      this.addOrderOutForm.patchValue({
        invoiceNumber: '',
        invoiceDate: '',
        invoiceFile: '',
        invoice: ''
      });
      this.selectedFile = null;
    }
  }

  initData() {
    this.tyreSizeObj.searchTerm = "";
    this.tyreSizeObj.page = 0;
    this.tyreMakeObj.searchTerm = "";
    this.tyreModelObj.name = "";
    this.getTyreSize();
    this.getTyreMake();
  }

  onSizeClose() {
    if (this.tyreSizeObj.searchTerm) {
      this.tyreSizeObj.page = 0;
      this.tyreSizeObj.searchTerm = '';
      this.getTyreSize();
    }
  }

  onMakeClose() {
    if (this.tyreMakeObj.searchTerm) {
      this.tyreMakeObj.page = 0;
      this.tyreMakeObj.searchTerm = '';
      this.getTyreMake();
    }
  }

  onModelClose(index: number) {
    if (this.modelList[index].search) {
      this.modelList[index].page = 0;
      this.modelList[index].search = '';
      
      this.tyreModelObj.page = 0;
      this.tyreModelObj.name = '';
      
      let selectedGroup: any = this.stock?.controls[index];
      let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
      this.tyreModelObj.tyreMake = selectedTyreMake;
      
      this.getTyreModel(index, this.tyreModelObj);
    }
  }

  onFileSelected(event: any) {
    const file: File = event?.target?.files?.[0];
    if (!file) return;
    const allowed = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
    if (!allowed.includes((file.type || '').toLowerCase())) {
      this.responseMsg = 'Only PDF and standard image files (JPG, PNG, WEBP) are allowed.';
      this.selectedFile = null;
      event.target.value = '';
      return;
    }
    this.responseMsg = '';
    this.selectedFile = file;
  }

  saveOrderOutData() {
    if (this.showUploadForm && this.selectedFile) {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      this.stockService.uploadFile(formData).subscribe({
        next: (res: any) => {
          const cloudUrl = res?.data?.[0]?.cloudUrl || '';
          this.addOrderOutForm.patchValue({ invoice: cloudUrl });
          this.doSave();
        },
        error: (error: any) => {
          this.handleError(error);
        }
      });
    } else {
      this.doSave();
    }
  }

  doSave() {
    this.isLoading = true;
    const formValue = this.addOrderOutForm.getRawValue();
    if (this.selectedStockInId) {
      if (this.editParamMode === 'editId') {
        this.stockService.saveStockInEdit(this.selectedStockInId, { stock: formValue.stock, reason: formValue.editReason }).subscribe({
          next: (res: any) => {
            this.redirectTolist(res);
          },
          error: (error: any) => {
            this.handleError(error);
          }
        });
      } else if (this.editParamMode === 'udid') {
        delete formValue.editReason;
        this.stockService.updateStockIn(this.selectedStockInId, formValue).subscribe({
          next: (res: any) => {
            this.redirectTolist(res);
          },
          error: (error: any) => {
            this.handleError(error);
          }
        });
      } else {
        const updatePayload: any = { ...formValue };
        delete updatePayload.editReason;

        if (this.isStockChanged) {
          this.stockService.updateStockIn(this.selectedStockInId, updatePayload).subscribe({
            next: () => {
              this.stockService.saveStockInEdit(this.selectedStockInId, { stock: formValue.stock, reason: formValue.editReason }).subscribe({
                next: (res: any) => {
                  this.redirectTolist(res);
                },
                error: (error: any) => {
                  this.handleError(error);
                }
              });
            },
            error: (error: any) => {
              this.handleError(error);
            }
          });
        } else {
          this.stockService.updateStockIn(this.selectedStockInId, updatePayload).subscribe({
            next: (res: any) => {
              this.redirectTolist(res);
            },
            error: (error: any) => {
              this.handleError(error);
            }
          });
        }
      }
    } else {
      delete formValue.editReason;
      this.stockService.saveStockInDetails(formValue).subscribe({
        next: (res: any) => {
          this.redirectTolist(res);
        },
        error: (error: any) => {
          this.handleError(error);
        }
      });
    }
  }

  handleError(error: any) {
    this.isLoading = false;
    this.responseMsg = error?.error?.error?.message || error?.error?.message || error?.error || error.message || "Something went wrong, failed to save data"
  }

  redirectTolist(res: any) {
    setTimeout(() => {
      this.messageService.sendMessage(res.message);
    })
    this.router.navigate(['/product-list'])
  }

  onDealerInputChange(event: any) {
    this.dealerObj.page = 0;
    this.dealerList = [];
    let delearSearch = event?.term ? event.term : '';
    this.dealerObj.searchTerm = delearSearch;
    this.getDealers();
  }

  scrollDealer() {
    if (this.endOfDealerList) {
      return;
    } else {
      this.dealerObj.page++
      this.getDealers()
    }
  }

  getFreightDetails(index: any) {
    const tyreSize = this.addOrderOutForm.value.stock[index].tyreSize;
    const tyreMake = this.addOrderOutForm.value.stock[index].tyreMake;
    const tyreModel = this.addOrderOutForm.value.stock[index].tyreModel;
    let payload : any ={
    tyreSize,
    tyreMake,
    tyreModel
    }
    if (!tyreSize || !tyreMake) {
      return;
    }
    if (this.modelList?.length) {
      if (!tyreModel) {
        return;
      }
    }
      this.stockService.freightDetails(payload).subscribe({
      next: (res: any) => {
        setTimeout(() => {
          this.priceDetailsArray[index] = {
            minPrice: res?.data?.minPrice || 0,
            maxPrice: res?.data?.maxPrice || 0,
            avgPrice: res?.data?.avgPrice || 0,
          };
          this.stock.at(index).patchValue({
            minAmount: res?.data?.minPrice || 0,
            maxAmount: res?.data?.maxPrice || 0
          });
        });
        this.responseMsg = '';
      },
      error: (error) => {
        this.responseMsg = error?.error?.error?.message;
      }
      });
  }
  
}
